module.exports = {
  OTP: {
    HEADING: 'Mobile Number/Email Verification',
    HEADING_ESIGN: 'Consent for Account Opening',
    SUBHEADING:
      'One Time Password (OTP) has been sent to your mobile and email ID.',
    PAN: 'Permanent Account Number (PAN)',
    EXPIRE_OTP: 'OTP will expire in',
    RESEND_OTP: 'RESEND OTP'
  },
  APP: {
    MAINTAINANCE_TIME:
      'Online account opening facility available between 6 AM to 11 PM',
    IDLE_TIME: 'You have been idle since 1 minutes. Please try again.',
    DEBOUNCE: 250,
    IDLE_TIMEOUT: 15 * 60 * 1000, // 15 minutes
  },
  REKYC_TAG: {
    IDLE_TIMEOUT: 15 * 60 * 1000,
  },
  PEBBLE_TAG:{
    IDLE_TIMEOUT: 3 * 60 * 1000,
  },
  DGOV_TAG:{
    IDLE_TIMEOUT: 3 * 60 * 1000,
  },
  NLI_TAG:{
    IDLE_TIMEOUT: 30 * 60 * 1000,
    SESSION_ABOUT_TO_TIMEOUT: 25 * 60 * 1000,
  },
  DUALRES_TAG:{
    IDLE_TIMEOUT: 3 * 60 * 1000,
  }, 
  NON_CSP_CHANNELS: ['CSP-IMOBILE','VRM' , 'CIB' ,'INSTABIZ','RIB','STANDALONE'],
  NON_CSP_CHANNELS_INCLUDES_CSR: ['CSP-IMOBILE', 'CIB' ,'INSTABIZ','RIB','CSR',"STANDALONE"],
  SOMETHING_WENT_WRONG: 'Something went wrong! Please try after some time',
  TECHNICAL_ERROR:
    'Some technical error occured, Please try again after some time.',
  PERSONAL_DETAILS: {
    ENTER_ALL_FIELDS: 'Please enter all the fields',
    COMBINATION_OF_MOBILE_PAN:
      'Combination of mobile and Permanent Account Number (PAN) is already used, request you use Track to resume your journey',
    ENTER_OTP_WRONG: 'Otp entered is wrong',
    ENTER_PAN_FOR_TRAVEL_CARD_HOLDER:
      'Please enter the Permanent Account Number (PAN) card details of the Travel Card holder',
    PAN_VALIDATION_FAILED:
      'Permanent Account Number (PAN) validation has failed. Your Savings Account cannot be opened.',
    COMBINATION_OF_PAN:
      'Permanent Account Number (PAN) is already used, request you use Track to resume your journey',
    ENTERED_OTP_EXPIRED: 'Enterd otp has been expired',
    RESPONSE_FROM_PAN_SERVICE_DOWN:
      'We are unable to get a response on the verification of Permanent Account Number (PAN). It could be an intermittent technical issue. Please try again after some time.'
  },
  DUALRES_TAGS : {
    SUBMIT:'Submit',
    SUCCESS_MSG: 'All your account/s will be converted to Resident account/s',
    EXP_MESSAGE:'Your session has been expired. Kindly login and try again',
    MANDATORY_ERR:'it is mandatory to select your residential status',
    ERR_MESSAGE:'Thank you for the patience. We are currently facing difficulty in getting response. Request you to please try after sometime.',
    INACTIVE_MSG : 'Session expired! You have been inactive for too long.',
  },
  AADHAAR_DETAILS: {
    AADHAAR_SIM_PERCENTAGE: 0.8,
    GIC_AADHAAR_SIM_CHECK:
      'Your digital journey is interrupted because the Name fetched against your PAN and Aadhaar don’t match.\nWe don’t want you to miss out on your exclusive invite for unlimited cashback through your Amazon Pay card.\nOur representative will get in touch with you in 2 working days to help you complete your application!'
  },
  TRACK_APPLICATION: {
    HOUR_DIFFERENCE: 5000 //Changed to 5000 -- CR :: 09-July-2020 earlier value 48
  },
  VIDEO_KYC: {
    COMPLETE_YOUR_VKYC:
      'Complete Your Video KYC immediately and have an account without any limitations',
    PLEASE_ENSURE: 'Please ensure the following:',
    P1: 'Keep your original PAN card ready',
    P2: 'Be ready with pen and blank white paper for signature',
    P3:
      'Stable network connectivity and be in lighted up place to ensure clear visibility',
    UNABLE_TO_PROCESS_REQUEST:
      'We are currently unable to process your request, please try after sometime.\nOur official will get in touch with you shortly to complete your biometric verification.',
    VIDEO_AUDIO_NOT_FOUND:
      "To initiate Video KYC, you need to have camera & microphone facility in your 7/ desktop.\nAlternatively, you can reinitiate Video KYC through mobile phone by using 'Track Application' option available in buy.icicibank.com",
    TNC_TEXT: {
      T1: ' I confirm that I have read, understood and accept the applicable ',
      T2: 'Video KYC T&C'
    },
    KYC_COMPLETED: 'KYC COMPLETED',
    TRY_AFTER_SOMETIME: 'Try Video KYC in 1-2 minutes'
  },
  userVerification: {
    WHO_ARE_YOU: 'Who are You ?', //remove this
    PAN_DOB: 'Permanent Account Number (PAN) and Date of Birth (DoB)',
    PAN_MOBILE: 'Permanent Account Number (PAN) and Mobile Number',
    AADHAAR_MOBILE: 'Aadhaar and Mobile Number',
    MOBILE_DOB: 'Mobile Number and Date of Birth (DoB)',
    ID_BY_AADHAAR: 'Identification by Aadhaar Number',
    AADHAAR_NUMBER: 'Aadhaar Number',
    ID_BY_DOB: 'Identification by Date of Birth (DoB)',
    UPDATE: 'Update',
    ENTER_MOBILE_NO: 'Enter Mobile Number',
    SELECT_THE_MONTH: 'Select the Month',
    SELECT_THE_YEAR: 'Select the Year',
    SELECT_THE_DAY: 'Select the Date',
    // ID_BY_PAN: 'Identification by Permanent Account Number (PAN)',
    ID_BY_ACCOUNT_NUMBER: 'Identification by Account Number',
    LET_ME_VALIDATE: 'Let me validate myself !',
    VALIDATE_MYSELF: 'Validate myself !',
    // VALIDATION_VIA_OTP: "OTP will be triggered on your registered mobile number",
    VALIDATION_VIA_OTP: "One-Time Password has been sent on your registered mobile number",
    VALIDATION_VIA_OTP_WITH_EMAIL: 'One-Time Password has been sent on your registered mobile number and Email-ID both.',
    VALIDATION_VIA_AADHAROTP: 'Validation of AADHAAR via One Time Password',
    VALIDATIONAADHAROTP:'One-Time Password (OTP) has been sent to your mobile number registered with UIDAI. Please enter to verify your Aadhaar number',
    AADHAARSUCCESS:'One-Time Password (OTP) for Aadhaar Number verified successfully',
    OTP: 'Enter OTP',
    RESEND_OTP: 'Resend OTP',
    RESEND_LINK: 'Resend Link',
    // ID_BY_MOBILE_NUMBER: 'Identification by Mobile Number',
    IDBYMOB: 'Identification by Mobile Number',
    ID_BY_MOBILE_NUMBER: 'Help me to identify you',
    //ID_BY_MOBILE_NUMBER:'Help me to identify you Identification by Mobile Number',
    // PLEASE_ENTER_TWO_VALUES: 'Enter details to identify',
    PLEASE_ENTER_TWO_VALUES:
      'Please choose any two values to identify your credentials',
    SELECT_ANY_TWO: '(select any two)',
    ACCOUNT_NUMBER: 'Enter Account Number',
    PAN_NUMBER: 'Permanent Account Number (PAN)',
    MOBILE_NUMBER: 'Mobile Number',
    DOB: 'Date of Birth (DoB)',
    ID_BY: 'Identification by',
    SELECT_THE_MONTH: 'Select Month',
    SELECT_THE_YEAR: 'Select Year',
    SELECT_THE_DAY: 'Select Date',
    // ID_BY_PAN: 'Identification by Permanent Account Number (PAN)',
    // ID_BY_PAN: 'Help me to identify you Identification by PAN',
    ID_BY_PAN: 'Help me to identify you',
    ENTERMOB: 'Enter your Mobile Number',
    ENTERPAN: 'Enter your PAN',
    IDBYPAN: 'Identification by PAN',

    HI: 'Hi',
    CURRENT_EMAIL_ID: 'Current Email Id: ',
    ENTER_NEW_EMAIL_ID: 'Enter new Email Id',
    ENTER_NEW_USER_NAME: 'Enter new Employer Name',

    CURRENT_PAN_NUMBER: 'Current PAN Number: ',
    ENTER_NEW_PAN_NUMBER: 'Enter new Pan Number',
    CURRENT_USER_NAME: 'Current User Name'
  },
  overDue: {
    HEADER: 'My dues at a glance:',
    NO_DATA: ' You do not have any over dues.',
    NOTE: 'In case you require any further information, you may visit the nearest ICICI Bank Loan Servicing Branch. Please',
    // NOTE:
    //   'In the event of any queries / disputes, you may approach your nearest Debt servicing Branch or can write to',
    TERMSANDCONDITIONS: 'Terms and Conditions Apply',
    WEBLINK: 'customer.care@icicibank.com',
    LINKS: 'https://www.icicibank.com/find-atm-branch/loan-servicing-branches?',
    LINK: ' click here',
    NOTES: 'to view the list of Loan Servicing Branches. Alternatively, you may write to us at',
    NOTECONTENT: 'from your registered e-mail ID',
    WHATSAPPTXT: 'send me Whatsapp notifications on',
    CLICKHERE: 'Click here',
    TERMSANDCONDITION: 'Terms and Conditions',
  },
  fileTypeText: 'Drag and Drop .png, .jpeg, .jpg, .pdf files here',
  REKYC_TAGS: {
    REFRESH_TOKEN_TIMER: 12 * 60 * 1000,
    LOCATION_PERMISSION_ERROR: "User denied permission",
    LOCATION_UNAVAILABLE_ERROR: "User location not available",
    LOCATION_TIMEOUT_ERROR: "User location permission timeout",
    LOCATION_UNKNOWN_ERROR: "Unknown Error occurred",
    FATCA_CONFIRMATION: "Fatca confirmation",
    PAN_NO_MATCH_ERROR: "PAN does not match",
    PAN_NOT_EXIST_ERROR: "PAN does not exist",
    PAN_INVALID_ERROR: "Invalid PAN",
    TERMSANDCONDITION: "Terms & Conditions"
  },

  REKYC_API_TAGS: {
    TOKEN_EXPIRED: "token.expired",
    PAN_FETCH_NOMATCH: "pan.fetch.nomatch",
    PAN_FETCH_FAILED: "pan.fetch.failure",
    PAN_FETCH_SUCCESS: "pan.fetch.success",
    PAN_FETCH_INVALID: "pan.fetch.invalid",
    EMAIL_FETCH_SUCCESS: "email.fetch.success",
    EMAIL_FETCH_ERROR: "email.fetch.failure",
    C360_FETCH_SUCCESS: "c360.fetch.success",
    C360_FETCH_ERROR: "c360.fetch.failure",
    AADHAAR_FETCH_ERROR: "aadhaar.fetch.failure",
  },
  FATCACRS_PDF_URL: "https://www.icicibank.com/managed-assets/docs/nri/FATCA/FATCA-n-CRS.pdf?_gl=1*1y1s04n*_ga*Njc1MDUzNDAyLjE2Njg2MDM3ODQ.*_ga_SKB78GHTFV*MTY3MDgzNjMzMS4xNy4xLjE2NzA4MzY4MTYuMzcuMC4w",
  ACCOUNT_STATUS_UNABLE: "Unable",
  ACCOUNT_STATUS_OPEN: "Open",
  ACCOUNT_STATUS_AGENTASSIGNED: "AgentAssigned",
  ACCOUNT_STATUS_AUDITORASSIGNED: "AuditorAssigned",
  ACCOUNT_STATUS_AUDITORREADY: "AuditorReady",
  ACCOUNT_STATUS_SUCCESSFUL: "Successful",
  ACCOUNT_STATUS_APPROVED: "Approved",
  ACCOUNT_STATUS_REJECTED: "Rejected",
  ACCOUNT_STATUS_NOTAPPROVED: "NotApproved",
  ACCOUNT_STATUS_REOPEN: "Reopen",
  ASSIST_MSG: {
    STEP_1: "Identify yourself (combination of Mobile and PAN).",
    STEP_2: "Validate your identity via OTP register Mobile.",
    STEP_3: "Request for the Service.",
    STEP_NOHEADER_FLAG1: "Identify customer (combination of Mobile and PAN)",
    STEP_NOHEADER_FLAG2: "Request for the Service.",
    STEP_NOHEADER_FLAG3: "Validate customer via Verification Link",
    OVERDUE_STEP1 : "Identify yourself (combination of PAN & Mobile no. OR PAN & DOB)",
    OVERDUE_STEP2 : "View and manage your overdues",
    OVERDUE_STEP3 : "Pay your overdues",
  },  
  
  // Data governance constants
  DGOV_TAGS : {
    CONFIRM:'Confirm',
    MODIFY:'Modify',
    CLICK_HERE:'Click Here',
    // DOB screen
    DOB_NOTE_NRI : 'Kindly send an email to nri@icicibank with valid document proof to update DOB',
    DOB_NOTE_NONNRI:'Kindly visit your nearest branch to Update Date of Birth',
    // MOBILE screen
    MOBILE_NOTE_NRI : 'Kindly call customer care to update mobile number',
    MOBILE_NOTE_NONNRI:'Kindly visit your nearest branch to Update Mobile Number',
    // CONTACT
    CONTACT_NOTE_NRI: "In case you haven't received OTP on SMS or CALL or EMAIL: Contact our 24-hour Customer Care.",
    CONTACT_NOTE_NONNRI: "Please do not share OTP with anyone, even if a person claims to be an ICICI Bank official. For further details please",
    // Profile
    PEOFILE_MANDATORY_ERR:'Please select all mandatory profile fields',
    // Pan not match
    PAN_NOT_MATCH:'PAN details not matched with system, please visit nearest branch',
    PAN_API_FAILS:'Currently unable to validate your request, kindly retry after sometime.',
    VALID_PAN_ERR:'Please enter valid PAN Number',
    PAN_NOTE_NRI: "Login to Internet banking > Customer Service > Service Request > Update Form 60",
    PAN_NOTE_NONNRI:'Kindly visit your nearest branch to Update Form 60',
    // other msgs
    NO_EMAIL_MSG : 'No Email found for this Account',
    EMAIL_INCORRECT_OTP:'OTP you have entered is Incorrect, Please try again..!',
    VALID_GRID_MSG:'Please enter valid grid Card details',
    EXIST_MAIL_ERR:'Your new Email cannot be same as existing',
    VALID_MAIL_ERR : 'Please enter valid Email ID',
    MAX_GRID_ATTEMPTS:'You have exceeded the maximum number of attempts to enter the correct Debit Grid details. Please try again.',
    DEBIT_ALERT:'Kindly keep your active debit card ready as the process requires GCA authentication to update E-mail ID'
  },

  // data quality 
  DATAQUALITY_TAG: {
    IDLE_TIMEOUT: 15 * 60 * 1000,
  },

  DATAQUALITY_TAGS: {
    REFRESH_TOKEN_TIMER: 12 * 60 * 1000,
    LOCATION_PERMISSION_ERROR: "User denied permission",
    LOCATION_UNAVAILABLE_ERROR: "User location not available",
    LOCATION_TIMEOUT_ERROR: "User location permission timeout",
    LOCATION_UNKNOWN_ERROR: "Unknown Error occurred",
    FATCA_CONFIRMATION: "Fatca confirmation",
    PAN_NO_MATCH_ERROR: "PAN does not match",
    PAN_NOT_EXIST_ERROR: "PAN does not exist",
    PAN_INVALID_ERROR: "Invalid PAN",
    TERMSANDCONDITION: "Terms & Conditions"
  },
 
  DATAQUALITY_API_TAGS: {
    TOKEN_EXPIRED: "token.expired",
    PAN_FETCH_NOMATCH: "pan.fetch.nomatch",
    PAN_FETCH_FAILED: "pan.fetch.failure",
    PAN_FETCH_SUCCESS: "pan.fetch.success",
    PAN_FETCH_INVALID: "pan.fetch.invalid",
    EMAIL_FETCH_SUCCESS: "email.fetch.success",
    EMAIL_FETCH_ERROR: "email.fetch.failure",
    C360_FETCH_SUCCESS: "c360.fetch.success",
    C360_FETCH_ERROR: "c360.fetch.failure",
    AADHAAR_FETCH_ERROR: "aadhaar.fetch.failure",
  },

  //QrCodePage
  QR_NOTE: "Please Note:",
  QR_NOTE_TEXT: "Once your payment is processed, kindly visit RIB > Credit Card Section to confirm the successful payment of your Credit Card dues.",
};
